export const formatNotificationDateTime = (
  iso: string,
): { date: string; time: string } | null => {
  if (!iso) return null;
  const parsed = new Date(iso);
  if (isNaN(parsed.getTime())) return null;
  return {
    date: parsed.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    time: parsed.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    }),
  };
};

// Flight No / Date / Time as one consolidated line, in that order, skipping
// any part that isn't available.
export const buildNotificationMetaLine = (
  flightNumber: string | undefined,
  isoTime: string,
): string => {
  const dateTime = formatNotificationDateTime(isoTime);
  return [flightNumber, dateTime?.date, dateTime?.time]
    .filter(Boolean)
    .join(" • ");
};

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// The message text and the Flight No/Date/Time line can both end up
// mentioning the flight number (backend copy, client enrichment, or a stale
// cached message from before either changed). When we're already showing the
// flight number on its own line, strip any "Flight <code>" mention out of the
// message text so it isn't shown twice.
export const stripFlightMention = (message: string, flightNumber?: string): string => {
  if (!message || !flightNumber) return message;
  const escaped = escapeRegExp(flightNumber);
  return message
    .replace(new RegExp(`\\s*for Flight ${escaped}\\b`, "i"), "")
    .replace(new RegExp(`\\s*Flight ${escaped}\\b`, "i"), "")
    .replace(/\s{2,}/g, " ")
    .trim();
};
